// Confirmed from Figma's "asset marker" component, which the refreshed Live Dashboard reuses
// for both map pins and network diagram nodes. Unlisted statuses fall back to the neutral tone.
// Values are literal Tailwind classes (not interpolated) so the static content scan detects them.
const REFRESHED_STATUS_TEXT_CLASS = {
    charging: "text-[#006618]",
    idle: "text-[#015394]",
    tracking: "text-[#565656]",
    working: "text-[#2708a2]"
};
export const REFRESHED_NEUTRAL_TEXT_CLASS = "text-[#565656]";
// Mirrors getNodeIconColor's precedence so a refreshed label never contradicts its status dot.
export const getEffectiveStatus = (activity, assetStatus) => {
    if (assetStatus === "Fault" || assetStatus === "Off")
        return assetStatus;
    const chargerStatus = assetStatus || activity;
    if (["available", "inoperable", "occupied"].includes(chargerStatus?.toLowerCase() ?? ""))
        return chargerStatus;
    return activity || assetStatus;
};
export const getRefreshedStatusTextClassName = (status) => {
    if (!status)
        return REFRESHED_NEUTRAL_TEXT_CLASS;
    const key = status.toLowerCase().replace(/[\s_]+/g, "");
    if (key === "accharging" || key === "dccharging")
        return REFRESHED_STATUS_TEXT_CLASS.charging;
    return REFRESHED_STATUS_TEXT_CLASS[key] ?? REFRESHED_NEUTRAL_TEXT_CLASS;
};
